import { css } from "lit";

export const styles = css`
  :host {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .social-links-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    width: 100%;
  }

  .social-links-title {
    margin: 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-subheading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.5;
  }

  .social-links-list {
    display: flex;
    flex: 1 0 0%;
    flex-direction: column;
    overflow-y: auto;
    gap: var(--sds-size-space-300);
    width: 100%;
  }

  .add-more-button {
    display: grid;
    align-items: center;
    width: 100%;
    padding: var(--sds-size-space-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background-color: var(--sds-color-background-default-tertiary);
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-align: left;

    grid-template:
      " icon text" auto
      / auto 1fr;
    gap: var(--sds-size-space-400);

    &:hover {
      background-color: var(--sds-color-background-default-tertiary-hover);
    }
  }

  .add-more-icon-container {
    grid-area: icon;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .add-more-icon {
    color: var(--sds-color-text-default-default);
  }

  .add-more-text {
    grid-area: text;
    margin: 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
  }

  .skeleton-text-group {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
    flex: 1;
  }
`;
